import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dc_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("dc_token", t);
  else localStorage.removeItem("dc_token");
};

export const getToken = () => localStorage.getItem("dc_token");

export const setAdminToken = (t) => {
  if (t) localStorage.setItem("dc_admin_token", t);
  else localStorage.removeItem("dc_admin_token");
};
export const getAdminToken = () => localStorage.getItem("dc_admin_token");

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dc_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const photoUrl = (id) => `${API}/photos/${id}?auth=${encodeURIComponent(getToken() || "")}`;
export const adminPhotoUrl = (id) => `${API}/photos/${id}?auth=${encodeURIComponent(getAdminToken() || "")}`;
